import type {ApiDiagramDiagram} from "~/types/generated/contentTypes";

export const useModalsStore = defineStore(
    'modals',
    () => {
        const {findOne} = useStrapi()
        const addedToCart
            = ref<{
            visible: boolean,
            diagram: ApiDiagramDiagram | null,
            relatedDiagrams: ApiDiagramDiagram[]
        }>
        ({
            visible: false,
            diagram: null,
            relatedDiagrams: []
        })

        const preview = ref({})

        const showAddedToCartModal = async (diagram: ApiDiagramDiagram) => {
            const relatedDiagrams = await findOne('diagrams', {
                filters: {id: diagram.id},
                fields: ['name'],
                populate: {
                    related_to: {
                        fields: ["url", "value_description", "title", "meta_description", "price", "legacy_id"],
                        populate: {
                            image: "*"
                        }
                    }
                }
            })
            addedToCart.value = {
                relatedDiagrams,
                diagram,
                visible: true
            }
        }

        return {
            showAddedToCartModal,
            addedToCart,
            preview,
        }

    }
)